/* Stacked fan carousel for the category tiles: drag or swipe, arrows, click a side card
   to bring it forward, click the front card to open the collection. */
class IceCatStack extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('[data-stage]');
    this.cards = [...this.querySelectorAll('[data-card]')];
    this.n = this.cards.length;
    if (!this.n) return;
    this.p = 0;
    this.target = 0;
    this.config();
    window.addEventListener('resize', () => { this.config(); this.render(); });

    let start = 0, x0 = 0, lastX = 0, lastT = 0, v = 0;
    this.moved = false;
    this.stage.addEventListener('pointerdown', (e) => {
      this.dragging = true; this.moved = false;
      start = this.p; x0 = lastX = e.clientX; lastT = performance.now(); v = 0;
      cancelAnimationFrame(this.raf);
    });
    this.stage.addEventListener('pointermove', (e) => {
      if (!this.dragging) return;
      const now = performance.now();
      v = (e.clientX - lastX) / Math.max(now - lastT, 1) * 1000;
      lastX = e.clientX; lastT = now;
      if (!this.moved && Math.abs(e.clientX - x0) > 6) {
        // capture only once a real drag starts, so a simple tap stays a click on the link
        this.moved = true;
        this.stage.setPointerCapture(e.pointerId);
      }
      if (!this.moved) return;
      this.p = start - (e.clientX - x0) / this.c.sensitivity;
      this.render();
    });
    const end = (e) => {
      if (!this.dragging) return;
      this.dragging = false;
      if (!this.moved) return;
      const dx = e.clientX - x0;
      let shift = Math.round(-dx / this.c.distance - v / this.c.velocity);
      shift = Math.max(-3, Math.min(3, shift));
      this.go(Math.round(start) + shift);
    };
    this.stage.addEventListener('pointerup', end);
    this.stage.addEventListener('pointercancel', end);

    this.cards.forEach((card, i) => {
      card.addEventListener('click', (e) => {
        if (this.moved) { e.preventDefault(); return; }
        if (Math.abs(this.offset(i)) > 0.3) { e.preventDefault(); this.go(this.p + this.offset(i)); }
      });
    });
    this.querySelector('[data-prev]').addEventListener('click', () => this.go(Math.round(this.target) - 1));
    this.querySelector('[data-next]').addEventListener('click', () => this.go(Math.round(this.target) + 1));
    this.render();
  }

  config() {
    const w = window.innerWidth;
    this.c = w < 640
      ? { distance: 120, velocity: 500, sensitivity: 180, x: 90, y: 20, r: 8, s: 0.06 }
      : w < 1024
        ? { distance: 160, velocity: 650, sensitivity: 220, x: 130, y: 30, r: 10, s: 0.09 }
        : { distance: 200, velocity: 800, sensitivity: 250, x: 170, y: 40, r: 12, s: 0.12 };
  }

  offset(i) {
    let d = (i - this.p) % this.n;
    if (d > this.n / 2) d -= this.n;
    if (d < -this.n / 2) d += this.n;
    return d;
  }

  go(t) {
    this.target = Math.round(t);
    cancelAnimationFrame(this.raf);
    let vel = 0;
    const step = () => {
      // critically damped spring toward the target index
      const force = (this.target - this.p) * 0.12 - vel * 0.55;
      vel += force;
      this.p += vel;
      if (Math.abs(this.target - this.p) < 0.001 && Math.abs(vel) < 0.001) {
        this.p = this.target;
        this.render();
        return;
      }
      this.render();
      this.raf = requestAnimationFrame(step);
    };
    this.raf = requestAnimationFrame(step);
  }

  render() {
    const { x, y, r, s } = this.c;
    const half = this.n / 2;
    this.cards.forEach((card, i) => {
      const o = this.offset(i);
      const a = Math.abs(o);
      const rot = a < 0.05 ? 0 : o * r;
      const lift = a < 0.05 ? 0 : a * y;
      let op = 1;
      if (a > half - 0.5) op = Math.max(0, (half - a) / 0.5);
      card.style.transform = `translate(-50%, -50%) translateX(${o * x}px) translateY(${lift}px) rotate(${rot}deg) scale(${1 - a * s})`;
      card.style.opacity = op;
      card.style.zIndex = Math.round(100 - a * 10);
      card.style.setProperty('--shade', Math.min(a * 0.3, 0.5));
      card.style.setProperty('--label', Math.max(0, 1 - a * 2));
      card.classList.toggle('is-front', a < 0.3);
      card.tabIndex = a < 0.3 ? 0 : -1;
    });
  }
}

if (!customElements.get('ice-cat-stack')) customElements.define('ice-cat-stack', IceCatStack);
